import axios from "axios";
import { Api } from "../../helper/ApiList";
import {
  DRIVER_REQUEST,
  DRIVER_SUCCESS,
  DRIVER_FAIL,
} from "../constants/Constants";
import { loaderAction } from "./loaderAction";

export const driver = (token) => async (dispatch) => {
  dispatch(loaderAction(true));

  dispatch({ type: DRIVER_REQUEST });

  const { data } = await axios({
    method: "post",
    headers: { Authorization: `${token}` },
    url: `${Api.getDriversList}`,
  });

  if (data.response) {
    console.log(data.response, "svd");
    const { status, result } = data.response;

    dispatch(loaderAction(false));

    if (status.statusCode === 200) {
      if (result.length === 0) {
        dispatch({ type: DRIVER_SUCCESS, payload: result });
        dispatch(loaderAction(false));
      } else {
        let arr = [];
        result &&
          result.forEach((store, index) => {
            store.index = index + 1;

            arr.push(store);
          });
        dispatch({ type: DRIVER_SUCCESS, payload: arr && arr });
        dispatch(loaderAction(false));
      }
    }
  } else {
    dispatch({ type: DRIVER_FAIL });

    dispatch(loaderAction(false));
  }
};
